import React from "react";
import { FiBell, FiMenu } from "react-icons/fi"; // Added FiMenu for the mobile hamburger trigger
import { FaRegMoon } from "react-icons/fa";

import DataUpLogo from "../assets/images/DataUpLogoAuth.svg";
import { CountryIcon, Person } from "../assets/Icons";
import { useDarkMode } from "../context/DarkModeContext";
import { useAppSelector } from "../hooks/hooks";

interface NavbarProps {
  onMenuToggle?: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ onMenuToggle }) => {
  const { user } = useAppSelector((state) => state.auth);
  const { toggleDarkMode } = useDarkMode();
  return (
    <div className="bg-white dark:bg-BG-dark p-4 shadow-md w-full">
      <div className="flex items-center justify-between mx-2 lg:mx-6">
        {/* Logo and Mobile Menu Button Wrapper */}
        <div className="flex items-center gap-3">
          <button
            onClick={onMenuToggle}
            className="p-2 text-2xl text-gray-600 dark:text-gray-300 lg:hidden hover:bg-gray-100 dark:hover:bg-zinc-800 rounded-lg transition-colors focus:outline-none"
            aria-label="Toggle Menu"
          >
            <FiMenu />
          </button>

          <div className="flex items-center">
            <img
              src={DataUpLogo}
              alt="Package"
              className="w-auto h-[32px] lg:h-[40px]"
            />
          </div>
        </div>

        {/* Action Controls */}
        <div className="flex items-center gap-2 lg:gap-4">
          <div className="bg-[#F4F4F5] dark:bg-[#FFFFFF1A] p-2 rounded-3xl cursor-pointer">
            <CountryIcon />
          </div>
          <div
            className="bg-[#F4F4F5] dark:bg-[#FFFFFF1A] p-2 rounded-3xl cursor-pointer"
            onClick={toggleDarkMode}
          >
            <FaRegMoon size={20} className="dark:text-white lg:text-[24px]" />
          </div>
          <div className="bg-[#F4F4F5] dark:bg-[#FFFFFF1A] flex items-center justify-center w-[36px] lg:w-[40px] h-[36px] lg:h-[40px] rounded-3xl cursor-pointer">
            <FiBell className="dark:text-white text-xl lg:text-2xl" />
          </div>

          <div className="flex gap-2 text-[10px] bg-[#F4F4F5] dark:bg-[#FFFFFF1A] rounded-[24px] h-[38px] lg:h-[45px] items-center px-3">
            <div className="flex items-center gap-[6px] lg:gap-[12px]">
              <Person />
              <div className="hidden sm:block">
                <p className="text-sm lg:text-lg font-semibold dark:text-white max-w-[80px] truncate">
                  {user?.firstname || "User"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
